module.exports = __webpack_public_path__ + "static/Pandemonium-small-36cf623af8b5e3902e3b7b91bc42790f.jpg";